import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AuthService } from './authentication/auth.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { SidebarState } from './utils';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PromptPwaUpdateService } from './services/prompt-pwa-update.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss',
  animations: [
    trigger('slideInOut', [
      state('in', style({ transform: 'translate3d(0, 0, 0)' })),
      state('out', style({ transform: 'translate3d(-110%, 0, 0)' })),
      transition('in => out', animate('200ms ease-in-out')),
      transition('out => in', animate('200ms ease-in-out')),
    ]),
    trigger('displayInOut', [
      state('in', style({ visibility: 'visible', opacity: 1 })),
      state('out', style({ visibility: 'hidden', opacity: 0 })),
      transition('in => out', animate('200ms ease-in-out')),
      transition('out => in', animate('200ms ease-in-out')),
    ]),
  ],
})
export class AppComponent implements OnInit {
  title: string = 'enjochem-admin';
  @ViewChild('contentUpdateModal') contentUpdateModal!: TemplateRef<any>;
  modalRef!: NgbModalRef;

  protected isAdminLoggedIn: boolean = false;
  protected isTabletMode!: boolean;
  protected sidebarState: SidebarState = SidebarState.OUT;
  protected isInitialDataLoading: boolean = false;
  protected isSidebarCollapsed: boolean = false;

  constructor(
    private _authService: AuthService,
    private modalService: NgbModal,
    private promptPwaUpdateService: PromptPwaUpdateService
  ) {}

  ngOnInit(): void {
    this._authService.isInitialDataLoading$.subscribe(loading => {
      this.isInitialDataLoading = loading;
    });

    this._authService.isLoggedIn().subscribe((isAdminLoggedIn: boolean): void => {
      this.isAdminLoggedIn = isAdminLoggedIn;
      this.isTabletMode = window.innerWidth < 1200;
      this.sidebarState = this.isTabletMode ? SidebarState.IN : SidebarState.OUT;

      if (isAdminLoggedIn) {
        this._authService.initializeSession().subscribe();
      }
    });

    this.isTabletMode = window.innerWidth < 1200;

    this.promptPwaUpdateService.showUpdateModal$.subscribe(isShow => {
      if (isShow && this.contentUpdateModal) {
        this.modalRef = this.modalService.open(this.contentUpdateModal, {
          backdrop: 'static',
        });
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(): void {
    this.isTabletMode = window.innerWidth < 1200;
    if (!this.isTabletMode && this.sidebarState === SidebarState.IN) {
      this.toggleMainSidebar();
    }
  }

  protected toggleMainSidebar(): void {
    if (!this.isTabletMode && this.sidebarState === SidebarState.OUT) return;
    document.body.classList.toggle('noscroll', this.sidebarState === SidebarState.OUT);
    this.sidebarState = this.sidebarState === SidebarState.OUT ? SidebarState.IN : SidebarState.OUT;
  }

  protected updateApp(): void {
    this.promptPwaUpdateService.forceAppUpdate();
  }

  protected closeModal(): void {
    this.modalRef?.close();
  }
}
